/**
 * The word both delete dialogs ask for, and the one rule that reads it.
 *
 * Deleting an account cannot be undone, which is why the dialog asks the member
 * to TYPE a word rather than press a second button: the typing is the pause.
 *
 * Unlike COMBINE it is deliberately NOT case sensitive. Both screens print it
 * in ordinary sentence case ("Type **Delete** to confirm"), so folding the case
 * is what makes the check agree with the words on screen; refusing a capital D
 * would refuse exactly what was shown. Surrounding space is forgiven for the
 * same reason it is on the combine dialog, a keyboard slip rather than a
 * failure to read.
 *
 * It lives here because TWO screens ask it now. It used to be a comparison
 * written out inside the profile page, and the setup screen had no delete
 * control at all: a social sign-in that stopped at the wall was left holding an
 * account with only "Not you? Log out" on screen, which ends the session and
 * keeps the account. Two copies of a confirmation rule drift, and the one that
 * drifts is the one nobody is looking at.
 *
 * Pure and exported so it can be tested: this repo has no component-test
 * toolchain, and the rule is too important to live only inside a template.
 */
export const DELETE_CONFIRMATION = 'Delete';

export function deleteConfirmationAccepted(typed) {
  return typeof typed === 'string'
      && typed.trim().toLowerCase() === DELETE_CONFIRMATION.toLowerCase();
}
